// import Mixin from './mixin';
// import Logger from './logger';
// import Listener from './listener';
// import Emitter from './emitter';
// import jwtDecode from 'jwt-decode';
// // import SocketIO from 'socket.io-client';

// // export default class VueSocketIO {
// //   constructor({ connection, vuex, debug, options }) {
// //     Logger.debug = debug;
// //     this.io = this.connect(connection, options);
// //     this.useConnectionNamespace = options && options.useConnectionNamespace;
// //     this.namespaceName = options && options.namespaceName;
// //     this.emitter = new Emitter(vuex);
// //     this.listener = new Listener(this.io, this.emitter);
// //   }

// //   install(Vue) {
// //     const namespace = this.namespaceName || this.io.nsp.replace('/', '');

// //     if (this.useConnectionNamespace) {
// //       if (typeof app.config.globalProperties.$socket === 'object') {
// //         app.config.globalProperties.$socket = {
// //           ...app.config.globalProperties.$socket,
// //           [namespace]: this.io,
// //         };

// //         app.config.globalProperties.$vueSocketIo = { ...app.config.globalProperties.$vueSocketIo, [namespace]: this };
// //       } else {
// //         app.config.globalProperties.$socket = {
// //           [namespace]: this.io,
// //         };
// //         app.config.globalProperties.$vueSocketIo = { [namespace]: this };
// //       }
// //     } else {
// //       // Vue.prototype.$socket = this.io;
// //       // Vue.prototype.$vueSocketIo = this;
// //       if (app && app.config) {
// //         app.config.globalProperties.$socket = this.io;
// //         app.config.globalProperties.$vueSocketIo = this;
// //       }
// //       // app.config.globalProperties.$socket = (value) => {
// //       //   return this.io;
// //       // };
// //       // app.config.globalProperties.$vueSocketIo = (value) => {
// //       //   return this;
// //       // }
// //     }

// //     Vue.mixin(Mixin);

// //     Logger.info('Vue-Socket.io plugin enabled');
// //   }

// //   connect(connection, options) {
// //     if (connection && typeof connection === 'object') {
// //       Logger.info(`Received socket.io-client instance`);
// //       return connection;
// //     } else if (typeof connection === 'string') {
// //       // - Auth
// //       let unwrappedToken;
// //       if (localStorage.getItem('token')) {
// //         unwrappedToken = jwtDecode(localStorage.getItem('token').split(' ')[1]);
// //       }
// //       let io = SocketIO(connection, {
// //         ...options,
// //         query: {
// //           authorized: unwrappedToken ? unwrappedToken.exp * 1000 > Date.now() : false,
// //         },
// //       });

// //       Logger.info(`Received connection string`);
// //       return (this.io = io);
// //     } else {
// //       throw new Error('Unsupported connection type');
// //     }
// //   }
// // }
// import { io } from 'socket.io-client';

// export default {
//   constructor({ connection, vuex, debug, options }) {
//     Logger.debug = debug;
//     this.io = this.connect(connection, options);
//     this.useConnectionNamespace = options && options.useConnectionNamespace;
//     this.namespaceName = options && options.namespaceName;
//     this.emitter = new Emitter(vuex);
//     this.listener = new Listener(this.io, this.emitter);
//   },
//   install: (app, { connection, options }) => {
//     console.log('options: ', options);
//     const socket = io(connection, options);
//     console.log('socket nsp: ', socket);
//     const namespace = options.namespaceName || socket.nsp.replace('/', '');
//     console.log('namespace: ', namespace);
//     if (options && options.useConnectionNamespace) {
//       if (typeof app.config.globalProperties.$socket === 'object') {
//         app.config.globalProperties.$socket = {
//           ...app.config.globalProperties.$socket,
//           [namespace]: socket,
//         };

//         app.config.globalProperties.$vueSocketIo = { ...app.config.globalProperties.$vueSocketIo, [namespace]: this };
//       } else {
//         app.config.globalProperties.$socket = {
//           [namespace]: socket,
//         };
//         app.config.globalProperties.$vueSocketIo = { [namespace]: this };
//       }
//     } else {
//       // Vue.prototype.$socket = this.io;
//       // Vue.prototype.$vueSocketIo = this;
//       if (app && app.config) {
//         app.config.globalProperties.$socket = socket;
//         app.config.globalProperties.$vueSocketIo = this;
//       }
//       // app.config.globalProperties.$socket = (value) => {
//       //   return this.io;
//       // };
//       // app.config.globalProperties.$vueSocketIo = (value) => {
//       //   return this;
//       // }
//     }





//     console.log('socket: ', socket);
//     // Add a global property
//     app.config.globalProperties.$socket = socket;

//     // // Initialize the $vueSocketIo property if it doesn't exist
//     // app.config.globalProperties.$vueSocketIo = app.config.globalProperties.$vueSocketIo || {};

//     // // Assign the namespace to $vueSocketIo
//     // app.config.globalProperties.$vueSocketIo[options.namespace] = options.socketInstance;
  
//     // Optionally, provide a global mixin to handle socket events
//     app.mixin(Mixin);

//     // Provide the socket instance to be injected in components if needed
//     app.provide('socket', socket);
//   },
//   connect(connection, options) {
//     if (connection && typeof connection === 'object') {
//       Logger.info(`Received socket.io-client instance`);
//       return connection;
//     } else if (typeof connection === 'string') {
//       // - Auth
//       let unwrappedToken;
//       if (localStorage.getItem('token')) {
//         unwrappedToken = jwtDecode(localStorage.getItem('token').split(' ')[1]);
//       }
//       let io = SocketIO(connection, {
//         ...options,
//         query: {
//           authorized: unwrappedToken ? unwrappedToken.exp * 1000 > Date.now() : false,
//         },
//       });

//       Logger.info(`Received connection string`);
//       return (this.io = io);
//     } else {
//       throw new Error('Unsupported connection type');
//     }
//   }
// };


import Mixin from './mixin';
import Logger from './logger';
import Listener from './listener';
import Emitter from './emitter';
import { io } from 'socket.io-client';
import jwtDecode from 'jwt-decode';

const SocketPlugin = {
  install(app, { connection, vuex, debug, options }) {
    Logger.debug = debug;

    const createSocket = () => {
      return this.connect(connection, options);
    };

    const setSocketReference = (socketInstance) => {
      if (options && options.useConnectionNamespace) {
        if (typeof app.config.globalProperties.$socket === 'object') {
          app.config.globalProperties.$socket = {
            ...app.config.globalProperties.$socket,
            [namespace]: socketInstance,
          };
        } else {
          app.config.globalProperties.$socket = {
            [namespace]: socketInstance,
          };
        }

        app.config.globalProperties.$vueSocketIo = { ...app.config.globalProperties.$vueSocketIo, [namespace]: this };
      } else {
        app.config.globalProperties.$socket = socketInstance;
        app.config.globalProperties.$vueSocketIo = this;
      }

      if (process.env.NODE_ENV !== 'production') {
        window.$socket = socketInstance;
      }

      app.provide('socket', socketInstance);
    };

    let socket = createSocket();
    const namespace = options.namespaceName || socket.nsp.replace('/', '');

    this.useConnectionNamespace = options && options.useConnectionNamespace;
    this.namespaceName = options && options.namespaceName;
    this.emitter = new Emitter(vuex);
    this.listener = new Listener(socket, this.emitter);

    setSocketReference(socket);

    app.config.globalProperties.$getSocketConnectionStatus = (namespace = null) => {
      const sockets = app.config.globalProperties.$socket;
      if (namespace && sockets[namespace]) {
        return sockets[namespace].connected;
      } else if (sockets.connected !== undefined) {
        return sockets.connected;
      } else {
        return false;
      }
    };

    // Optionally, provide a global mixin to handle socket events
    app.mixin(Mixin);

    // keep alive
    const isTokenValid = () => {
      const token = localStorage.getItem('token');
      if (!token) {
        return false;
      }
      try {
        const unwrappedToken = jwtDecode(token.split(' ')[1]);
        return unwrappedToken.exp * 1000 > Date.now();
      } catch (e) {
        console.warn("[Socket.io] Token validation failed:", e);
        return false;
      }
    };

    const reconnectRooms = () => {
      const rooms = vuex.store.getters.getUserRooms || [];
      if (rooms.length) {
        socket.emit("joinRooms", rooms);
      }
    };

    const attachSocketHandlers = (sock) => {
      sock.on("connect", () => {
        console.info("[Socket.io] Connected");
        sock.io.opts.reconnection = true;
        vuex.store.commit("setConnected", true);
        reconnectRooms();
      });

      sock.on("disconnect", (reason) => {
        console.warn(`[Socket.io] Disconnected: ${reason}`);
        vuex.store.commit("setConnected", false);
      });
      sock.io.on("reconnect_attempt", () => {
        const token = localStorage.getItem("token")?.split(" ")[1] || "";

        sock.auth = {
          token,
          permissions: token ? jwtDecode(token).permissions : []
        };
        if (!isTokenValid()) {
          console.warn("JWT expired - cancelling reconnect");
          sock.io.opts.reconnection = false;
          sock.disconnect();
        }
      });
      sock.io.on("reconnect", () => {
        console.info("[Socket.io] Reconnected");
        vuex.store.commit("setConnected", true);
        reconnectRooms();
      });
    };

    const cleanupSocket = () => {
      if (socket) {
        socket.removeAllListeners();
        socket.io.removeAllListeners();
        socket.close();
      }
    };

    const reinitializeSocket = () => {
      cleanupSocket();
      socket = createSocket();
      setSocketReference(socket);
      this.listener = new Listener(socket, this.emitter);
      attachSocketHandlers(socket);
    };

    attachSocketHandlers(socket);

    // Provide the socket instance to be injected in components if needed
    app.provide('socket', socket);
  },
  connect(connection, options) {
    if (typeof connection === 'object') {
      Logger.info(`Received socket.io-client instance`);
      return connection;
    } else if (typeof connection === 'string') {
      let unwrappedToken;
      if (localStorage.getItem('token')) {
        unwrappedToken = jwtDecode(localStorage.getItem('token').split(' ')[1]);
      }
      const isTestEnv = window.location.hostname.includes('test');
      const socket = io(connection, {
        // ...options,
        transports: isTestEnv ? ['polling'] : ['websocket', 'polling'],
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 10000,
        randomizationFactor: 0.5,
        auth: {
          // authorized: unwrappedToken ? unwrappedToken.exp * 1000 > Date.now() : false,
          permissions: unwrappedToken ? unwrappedToken.permissions : [],
          token: localStorage.getItem('token') ? localStorage.getItem('token').split(' ')[1] : '',
        },
      });

      Logger.info(`Received connection string`);
      return socket;
    } else {
      throw new Error('Unsupported connection type');
    }
  }
};

export default SocketPlugin;
